import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { type TRuleWithTheme, useFelaEnhanced } from '@ackee/fela';

import { Title, TitleTypes, Text, TextTypes, LocalizedLink } from 'modules/ui';
import { MessageKey } from 'modules/intl';

import { PixelatedBackgroundContext } from '../../PixelatedBackgroundWrapper';

import * as felaRules from './Article.rules';

export interface ArticleProps {
    title: MessageKey;
    text: MessageKey;
    link: string;
    anchor: string;
}

export const Article = ({ title, text, link, anchor }: ArticleProps) => {
    const backgroundMode = useContext(PixelatedBackgroundContext);
    const { rules, styles } = useFelaEnhanced(felaRules, { backgroundMode });

    return (
        <article className={styles.box}>
            <LocalizedLink extend={{ link: rules.extendLink as TRuleWithTheme }} anchor={anchor} to={link}>
                {/* @ts-expect-error */}
                <Title extend={{ title: rules.extendTitle }} size={TitleTypes.H3} backgroundMode={backgroundMode}>
                    <FormattedMessage id={title} />
                </Title>
            </LocalizedLink>
            {/* @ts-expect-error */}
            <Text extend={{ text: rules.extendText }} type={TextTypes.NORMAL} backgroundMode={backgroundMode}>
                <FormattedMessage id={text} />
            </Text>
        </article>
    );
};
